module.exports = __webpack_public_path__ + "static/media/saldo64.b71f1c31.png";